(() => {
  const createGiftToken = () => {
    const bytes = new Uint8Array(32);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  };

  const initialize = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const button = root.querySelector('[data-social-gift-submit]');
    const error = root.querySelector('[data-social-gift-error]');
    const variantMapElement = root.querySelector('[data-social-gift-variant-map]');
    let variantMap = {};
    try {
      variantMap = JSON.parse(variantMapElement?.textContent || '{}');
    } catch (_error) {
      variantMap = {};
    }
    if (!button) return;

    const quantityInput = root.querySelector('[data-social-gift-quantity]');
    const variantSelect = root.querySelector('[data-social-gift-variant]');
    const priceElement = root.querySelector('[data-social-gift-price]');
    variantSelect?.addEventListener('change', () => {
      const selectedOption = variantSelect.selectedOptions[0];
      if (priceElement && selectedOption?.dataset.price) priceElement.textContent = selectedOption.dataset.price;
    });

    root.querySelectorAll('[data-quantity-change]').forEach((quantityButton) => {
      quantityButton.addEventListener('click', () => {
        if (!quantityInput) return;
        const min = Number(quantityInput.min || 1);
        const max = Number(quantityInput.max || 10);
        const next = Number(quantityInput.value || min) + Number(quantityButton.dataset.quantityChange || 0);
        quantityInput.value = String(Math.min(max, Math.max(min, next)));
      });
    });

    button.addEventListener('click', async () => {
      const sourceVariantId = variantSelect?.value || Object.keys(variantMap)[0];
      const variantId = Number(variantMap[sourceVariantId] || root.dataset.giftVariantId);
      const freeShipping = root.dataset.freeShipping === 'true';
      const feeVariantId = Number(root.dataset.feeVariantId || '');
      const serviceFeeYen = String(root.dataset.serviceFeeYen || '').trim();
      const receiveUrl = String(root.dataset.giftReceiveUrl || '').trim();
      const storeDomain = String(root.dataset.storeDomain || '').trim();
      const apiVersion = String(root.dataset.storefrontApiVersion || '').trim();
      const quantity = Math.min(10, Math.max(1, Number(quantityInput?.value || 1)));

      if (!variantId || (!freeShipping && !feeVariantId) || !/^\d+$/.test(serviceFeeYen) || !receiveUrl || !storeDomain || !apiVersion || !window.crypto?.getRandomValues) {
        error.textContent = 'ソーシャルギフトの設定が完了していません。';
        error.hidden = false;
        return;
      }

      const giftToken = createGiftToken();
      const giftUrl = `${receiveUrl}${receiveUrl.includes('?') ? '&' : '?'}gift=${encodeURIComponent(giftToken)}`;
      button.disabled = true;
      error.hidden = true;

      try {
        const response = await fetch(`https://${storeDomain}/api/${apiVersion}/graphql.json`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: `mutation SocialGiftCartCreate($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message } } }`,
            variables: {
              input: {
                lines: [
                  {
                    merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
                    quantity,
                    attributes: [
                      { key: '_social_gift', value: 'true' },
                      { key: '_social_gift_token', value: giftToken },
                      { key: '_social_gift_line_role', value: 'gift_item' },
                      { key: '_gift_url_expiry_days', value: root.dataset.expiryDays },
                      { key: '_gift_expiry_action', value: root.dataset.expiryAction },
                      { key: '_store_credit_expiry_days', value: root.dataset.creditExpiryDays },
                      { key: '_delivery_min_days', value: root.dataset.deliveryMinDays },
                      { key: '_delivery_max_days', value: root.dataset.deliveryMaxDays },
                      { key: '_social_gift_url', value: giftUrl },
                    ],
                  },
                  ...(!freeShipping ? [{
                    merchandiseId: `gid://shopify/ProductVariant/${feeVariantId}`,
                    quantity: 1,
                    attributes: [
                      { key: '_social_gift', value: 'true' },
                      { key: '_social_gift_token', value: giftToken },
                      { key: '_social_gift_line_role', value: 'delivery_fee' },
                      { key: '_gift_url_expiry_days', value: root.dataset.expiryDays },
                      { key: '_gift_service_fee_yen', value: serviceFeeYen },
                    ],
                  }] : []),
                ],
                attributes: [
                  { key: '_social_gift', value: 'true' },
                  { key: '_social_gift_token', value: giftToken },
                  { key: '_gift_service_fee_yen', value: serviceFeeYen },
                ],
              },
            },
          }),
        });

        if (!response.ok) throw new Error('cart_create_failed');
        const result = await response.json();
        const checkoutUrl = result?.data?.cartCreate?.cart?.checkoutUrl;
        if (result?.errors?.length || result?.data?.cartCreate?.userErrors?.length || !checkoutUrl) throw new Error('cart_invalid_response');
        window.SocialGiftCartGuard?.markCheckoutStarted();
        window.location.assign(checkoutUrl);
      } catch (_error) {
        error.textContent = '購入画面を開けませんでした。時間をおいてもう一度お試しください。';
        error.hidden = false;
        button.disabled = false;
      }
    });
  };

  const initializeAll = () => document.querySelectorAll('[data-mikoto-social-gift]').forEach(initialize);
  const restoreButtons = () => {
    document.querySelectorAll('[data-mikoto-social-gift] [data-social-gift-submit]').forEach((button) => {
      button.disabled = false;
    });
  };

  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
  window.addEventListener('pageshow', restoreButtons);
})();
